"use client";

import { useRouter } from "next/navigation";

export default function LogoutButton({ className }: { className?: string }) {
  const router = useRouter();

  async function logout() {
    await fetch("/api/auth/logout", { method: "POST" });
    router.refresh();
    router.push("/");
  }

  return (
    <button
      onClick={logout}
      className={
        className ??
        "border border-zinc-700 px-5 py-2 text-sm font-medium text-white transition hover:border-zinc-500 hover:text-white"
      }
    >
      Log out
    </button>
  );
}
